import './text-with-decorations.scss';


import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';

class TextWithDecorations {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);
		this.gsap();
	}

	gsap() {
		gsap.from('.text-with-decorations .circle',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .circle',
					start: 'center-=150 bottom',
				},
				opacity: 0,
				transform: 'rotate(-45deg)',
				duration: 1,
				delay: .3,
			});
		gsap.from('.text-with-decorations .button',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .button',
					start: 'center-=150 bottom',
				},
				opacity: 0,
				y: 100,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .title',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .title',
					start: 'center-=150 bottom',
				},
				y: 60,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .description',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .description',
					start: 'center-=150 bottom',
				},
				y: 80,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .photo-1',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				x: -100,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .photo-2',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				x: -100,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .photo-3',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				x: 100,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .sq-1',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				y: -100,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .sq-2',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				y: -100,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .sq-3',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				x: 70,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .sq-4',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				x: -70,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .sq-5',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				x: -35,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .sq-6',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .sq-7',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				y: 35,
				duration: 1,
				delay: .3
			});
		gsap.from('.text-with-decorations .sq-8',
			{
				scrollTrigger: {
					trigger: '.text-with-decorations .gallery__content',
				},
				opacity: 0,
				y: 70,
				duration: 1,
				delay: .3
			});
	}

}
new TextWithDecorations();
